import { scrollIntoView } from "@sprout/list-navigation";
export default function scrollPostIntoView(post) {
    const { id  } = post;
    const element = document.querySelector(`[data-id="${id}"]`);
    if (element) scrollIntoView(element);
};
